export const navigation = [{
  name: 'Calendario',
  url: '/calendario',
  icon: 'icon-calendar',
  roles: ['ADMINISTRADOR', 'ASESOR', 'MINORISTA']
},
{
  name: 'Catalogos',
  url: '/catalogo',
  icon: 'icon-star',
  roles: ['ADMINISTRADOR','MINORISTA','ASESOR'],
  children: [
    {
      name: 'Presencia de Marca',
      url: '/catalogo/articulos-marca',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR']
    },
    {
      name: 'Clasificaciones',
      url: '/catalogo/clasificaciones',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR']
    },
    {
      name: "Giros",
      url: '/catalogo/giros-clientes',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR']
    },
    {
      name: "Ocupaciones",
      url: '/catalogo/ocupaciones',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR']
    },
    {
      name: "Contactado En ",
      url: '/catalogo/contactado-en',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR']
    }, {
      name: "Productos",
      url: '/catalogo/productos',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR']
    }, {
      name: "Produtos Comparativa",
      url: '/catalogo/productos-comparativa',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR']
    }, {
      name: "Produtos Comparativa Minorista",
      url: '/catalogo/productos-comparativa-minorista',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR']
    }, {
      name: "Tipos Clientes",
      url: '/catalogo/tipos-clientes',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR']
    }, {
      name: "Tipos de Contacto",
      url: '/catalogo/tipos-contacto',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR']
    }, {
      name: "Tipos de Obra",
      url: '/catalogo/tipos-obra',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR']
    }, {
      name: "Tipos de Venta",
      url: '/catalogo/tipos-venta',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR']
    }, {
      name: "Asesores",
      url: '/catalogo/asesores',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR']
    }, {
      name: "Asesores Ciudades",
      url: '/catalogo/asesores-ciudades',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR']
    },
    {
      name: "Potencial Contactos",
      url: '/catalogo/potenciales-contactos',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR']
    },
    {
      name: "Rutas",
      url: '/catalogo/rutas-minoristas',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR','MINORISTA']
    },
    {
      name: "Tiendas HD",
      url: '/catalogo/tiendas-homedepot',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR','ASESOR']
    },
    {
      name: "Articulos Promocionales",
      url: '/catalogo/articulos-promocionales',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR']
    },
    {
      name: "Marcas Competencia HD",
      url: '/catalogo/marcas-competencia',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR','ASESOR']
    },
    {
      name: "SKUs Competencia HD",
      url: '/catalogo/skus-competencia',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR','ASESOR']
    },
    {
      name: "Tipos Tuberia",
      url: '/catalogo/tipos-tuberia',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR','ASESOR']
    },
    {
      name: "Compañías de Teléfono",
      url: '/catalogo/companias-telefono',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR']
    },
    {
      name: "Tipos Flyer",
      url: '/catalogo/tipos-flyer',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR']
    }

  ]
},
{
  title: 'true',
  name: 'Operación'
},
{
  name: 'Mayoristas',
  url: '/visitas',
  icon: 'icon-star',
  roles: ['ADMINISTRADOR', 'ASESOR'],
  children: [
    {
      name: 'Alta Visita',
      url: '/visitas/mayoristas/add',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MINORISTA']
    },
    {
      name: 'Listado Visita',
      url: '/visitas/mayoristas/list',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MINORISTA']
    },
    {
      name: "Resumen Ejecutivo",
      url: '/visitas',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MINORISTA']
    },
    {
      name: "Resumen de Participación",
      url: '/visitas/mayoristas/resumen-participacion',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MINORISTA']
    },
    {
      name: "Resumen Plan VS Real",
      url: '/visitas/mayoristas/programacion-vs-real',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR']
    },
    {
      name: "Mapa de rutas",
      url: '/visitas/mayoristas/mapa',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MINORISTA']
    }
  ]
},
{
  name: 'Reuniones Mayoristas',
  url: '/reuniones',
  icon: 'icon-star',
  roles: ['ADMINISTRADOR', 'ASESOR'],
  children: [
    {
      name: 'Listado de minutas',
      url: '/reuniones/minutas-list',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR']
    },
    {
      name: 'Acuerdos Minutas',
      url: '/reuniones/acuerdos-minutas-list',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR']
    },
    {
      name: 'Resumen Acuerdos Minutas',
      url: '/reuniones/resumen-acuerdos-minutas',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR']
    },
    {
      name: 'Area influencia',
      url: '/reuniones/area-influencia',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR']
    },
    {
      name: 'Estructura comercial',
      url: '/reuniones/estructura-comercial',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR']
    },
    {
      name: 'Pláticas Mayoristas',
      url: '/reuniones/platicas-mayoristas-list',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR']
    },
    {
      name: 'Reuniones Vendedores Mayoristas',
      url: '/reuniones/reunion-vendedores-mayoristas-list',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR']
    },
    {
      name: 'Reunion Vendedores Distribuidor',
      url: '/reuniones/reunion-vendedores-distribuidor-list',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR']
    },
    {
      name: 'Seguimiento Promociones',
      url: '/reuniones/seguimiento-promociones-list',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR']
    },
  ]
},
{
  name: 'Home Depot',
  url: '/homedepot',
  icon: 'icon-star',
  roles: ['ADMINISTRADOR','ASESOR'],
  children: [
    {
      name: 'Programacion Home Depot',
      url: '/homedepot/programacion',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR']
    },
    {
      name: 'Visitas Homedepot',
      url: '/homedepot/homedepot-list',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR']
    },
    {
      name: 'Reporte Ejecutivo HD',
      url: '/homedepot/reporte-ejecutivo-homedepot',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR','ASESOR']
    }
  ]
},
{
  name: 'Distribuidores',
  url: '/reuniones',
  icon: 'icon-star',
  roles: ['ADMINISTRADOR', 'ASESOR'],
  children: [
    {
      name: 'Reunion Vendedores Distribuidor',
      url: '/reuniones/reunion-vendedores-distribuidor-list',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR']
    },
    {
      name: 'Seguimiento Promociones',
      url: '/reuniones/seguimiento-promociones-list',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR']
    }
  ]
},
{
  name: 'Generales',
  url: '/generales',
  icon: 'icon-star',
  roles: ['ADMINISTRADOR', 'ASESOR','SEGUIMIENTO'],
  children: [
    {
      name: 'Proyectos logrados',
      url: '/generales/proyectos-logrados',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR']
    },
    {
      name: 'Potencial clientes',
      url: '/generales/potencial-clientes',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR']
    },
    {
      name: 'Potencial Segmento ABC',
      url: '/generales/potencial-contactos-2023',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR','SEGUIMIENTO']
    },
    {
      name: 'Edades Segmentos',
      url: '/generales/reporte-edades-segmentos',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR','SEGUIMIENTO']
    }

  ]
},
{
  name: 'Promociones',
  url: '/promociones',
  icon: 'icon-star',
  roles: ['ADMINISTRADOR', 'ASESOR', 'MINORISTA', 'SEGUIMIENTO'],
  children: [
    {
      name: 'Alta de promocion',
      url: '/promociones/add',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MINORISTA','SEGUIMIENTO']
    },
    {
      name: 'Listado promociones',
      url: '/promociones/list',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MINORISTA', 'SEGUIMIENTO']
    },
    {
      name: "Resumen de Ventas",
      url: '/promociones/ventas',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MINORISTA', 'SEGUIMIENTO']
    },
    {
      name: "Control",
      url: '/promociones/control',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MINORISTA', 'SEGUIMIENTO']
    },

  ]
},
{
  name: 'Seguimiento Contactos',
  url: '/promociones',
  icon: 'icon-star',
  roles: ['ADMINISTRADOR', 'ASESOR', 'SEGUIMIENTO', 'MINORISTA'],
  children: [
    {
      name: "Contactos Pendientes",
      url: '/promociones/contactos-pendientes',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MINORISTA', 'SEGUIMIENTO']
    },
    {
      name: "Alta de Contacto",
      url: '/promociones/contacto/',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MINORISTA', 'SEGUIMIENTO']
    },
    {
      name: "Contactos",
      url: '/promociones/contactos',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MINORISTA', 'SEGUIMIENTO']
    },
    {
      name: 'Alta Fechas ABC',
      url: '/visitas/abc/add',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'SEGUIMIENTO']
    },
    {
      name: 'Fechas ABC',
      url: '/visitas/a/b/c',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'SEGUIMIENTO']
    },
    {
      name: "Contactos por Semana",
      url: '/promociones/contactos-semana',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'SEGUIMIENTO']
    },
    {
      name: 'Eventos',
      url: '/promociones/eventos',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'SEGUIMIENTO']
    },
    {
      name: "Resumen Visitas",
      url: '/promociones/visitas',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MINORISTA', 'SEGUIMIENTO']
    },
    {
      name: "Detalle Visitas",
      url: '/promociones/detalle-visitas',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MINORISTA', 'SEGUIMIENTO']
    },
    {
      name: "Resultados Formatos",
      url: '/promociones/resultados-formatos',
      icon: 'icon-puzzle',
      roles:['ADMINISTRADOR', 'ASESOR', 'MINORISTA', 'SEGUIMIENTO']
    },
    {
      name: 'Reporte Eventos',
      url: '/reuniones/eventos-list',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'SEGUIMIENTO']
    },
    {
      name: 'Formatos Dinámicos',
      url: '/promociones/formularios-dinamicos',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR','SEGUIMIENTO']
    }
  ]
},
{
  name: 'Prospectos',
  url: '/prospectos',
  icon: 'icon-star',
  roles: ['ADMINISTRADOR'],
  children: [
    {
      name: 'Alta de Prospecto',
      url: '/prospectos/prospecto',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR']
    },
    {
      name: 'Prospectos',
      url: '/prospectos',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR']
    },
    {
      name: 'Recargas',
      url: '/prospectos/recargas',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR']
    },
    {
      name: 'Reporte',
      url: '/prospectos/reporte',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR']
    }

  ]
},
{
  name: 'Minoristas',
  url: '/minoristas',
  icon: 'icon-star',
  roles: ['ADMINISTRADOR', 'MINORISTA'],
  children: [
    {
      name: 'Programación',
      url: '/visitas/minoristas/list',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MINORISTA']
    },
    {
      name: "Resumen Ejecutivo",
      url: '/minoristas',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR', 'MINORISTA']
    },
    {
      name: "Resumen Alcaldías",
      url: '/minoristas/alcaldias',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR']
    }
  ]
},
{
  name: 'Segmentos V/IS/RS',
  url: '/segmentos',
  icon: 'icon-star',
  roles: ['ADMINISTRADOR', 'ASESOR'],
  children: [
    {
      name: 'Alta Manual',
      url: '/segmentos/alta-contacto-vist',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR']
    },
    {
      name: 'Obras',
      url: '/segmentos/contactos-list',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR']
    },
    {
      name: 'Obras en Proceso',
      url: '/segmentos/contactos-list-proceso',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR']
    },{
      name: 'Importar Inforte',
      url: '/segmentos/inforte',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR']
    },
    {
      name: 'Resumen de Visitas',
      url: '/segmentos/resumen-ejecutivo',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR', 'ASESOR']
    },
    {
      name: 'Proyectos Semana',
      url: '/segmentos/proyectos-semana',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR']
    },
    {
      name: 'Proyectos Convenios',
      url: '/segmentos/proyectos-convenios',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR']
    },
    {
      name: 'Proyectos Plan VS Real',
      url: '/segmentos/proyectos-real-plan',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR']
    },
    {
      name: 'Consumo Contactos Proyectos',
      url: '/segmentos/consumo-contactos-proyectos',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR']
    },
    {
      name: 'Contactos Mayor Consumo',
      url: '/segmentos/contactos-mayor-consumo',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR']
    },
    {
      name: 'Gráfica Proyectos en Proceso',
      url: '/segmentos/reporte-proyectos-proceso-especificacion',
      icon: 'icon-puzzle',
      roles: ['ADMINISTRADOR',"ASESOR"]
    }
  ]
},
{
  name: 'Salir',
  url: '/logout',
  icon: 'icon-close',
  roles: ['ADMINISTRADOR', 'ASESOR', 'MINORISTA', 'SEGUIMIENTO']
},
];



// WEBPACK FOOTER //
// /app/src/app/_nav.ts